import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import TimePicker from 'rc-time-picker'
import moment from 'moment'
import 'react-datetime/css/react-datetime.css'
import './InputTimeInput.scss'

export default class InputTimeInput extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    fieldValue: PropTypes.number,
    endTime: PropTypes.number,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
  }

  render() {
    // Take start of day to add slackTime to, so we can use this value
    // as a date value to visualise the hours and minutes of the slackTime to
    const valueInMs = this.props.fieldValue ? startOfDay() + this.props.fieldValue : startOfDay()

    return (
      <div className="input-time group">
        <label className={`header ${this.props.error ? 'error' : ''}`}>{this.props.name}</label>
        <div className="input-wrapper">
          <TimePicker
            value={moment(valueInMs)}
            showSecond={false}
            className={`${this.props.error ? 'error' : null}`}
            disabled={this.props.readOnly}
            onChange={this.handleChange}
          />
        </div>
        {this.props.error && <div className="input-error-message">{this.props.error}</div>}
      </div>
    )
  }

  handleChange = date => {
    // Remove the start of today time to get the actual selected slackTime again
    const actualDurationValue = date ? date.valueOf() - startOfDay() : null

    this.props.onChange(actualDurationValue, this.props.fieldName)
  }
}

function startOfDay() {
  return moment().startOf('day').valueOf()
}
